export default __webpack_public_path__ + "static/media/report_builder_logo.eaaae0765947df01eb1637c984e8026f.svg";